import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ShieldOff, Phone, Mail } from "lucide-react";
import { useLogout } from "@/hooks/useLogout";
import Loader from "@/components/ui/loader";
import PendingApprovalLayout from "@/components/layout/auth/PendingApprovalLayout";

const BlockedAccount = () => {
  const { user } = useAuth();
  const { logout, isLoggingOut } = useLogout();

  return (
    <PendingApprovalLayout>
      <Card className="border border-gray-200 rounded-2xl">
        <CardHeader className="text-center pb-4">
          <div className="flex justify-center mb-4">
            <img
              src="/assets/images/dark_extended.png"
              alt="Place2Be Logo"
              className="w-48 h-13 object-contain drop-shadow-lg"
            />
          </div>
          <CardTitle className="text-2xl text-gray-900 flex items-center justify-center gap-3">
            <ShieldOff className="h-6 w-6 text-red-500" />
            Account Bloccato
          </CardTitle>
          <CardDescription className="text-base text-gray-600">
            Il tuo account è stato sospeso. Contatta il nostro supporto per maggiori informazioni.
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-6">
          {user?.email && (
            <div className="bg-gray-50 rounded-lg p-4 text-center">
              <p className="text-gray-500 mb-1">Email</p>
              <p className="text-gray-700">{user.email}</p>
            </div>
          )}

          <div className="bg-red-50 rounded-lg p-4 border border-red-200">
            <h2 className="text-red-900 mb-3 text-center">
              Hai bisogno di assistenza?
            </h2>
            <div className="space-y-3">
              <div className="flex items-center justify-center gap-3">
                <Phone className="h-4 w-4 text-red-600" />
                <span className="text-red-800">+39 123 456 7890</span>
              </div>
              <div className="flex items-center justify-center gap-3">
                <Mail className="h-4 w-4 text-red-600" />
                <span className="text-red-800">support@place2be.com</span>
              </div>
            </div>
          </div>

          <div className="pt-2">
            <Button
              onClick={() => logout('/login')}
              disabled={isLoggingOut}
              variant="outline"
              className="w-full"
            >
              {isLoggingOut ? (
                <div className="flex items-center gap-2">
                  <Loader size="sm" className="mr-3" />
                  Uscendo...
                </div>
              ) : (
                'Esci dall\'Account'
              )}
            </Button>
          </div>
        </CardContent>
      </Card>
    </PendingApprovalLayout>
  );
};

export default BlockedAccount;
